module.exports = __webpack_public_path__ + "img/2.4397b3ea.png";